import { gql, useQuery, UseQueryArgs } from 'urql';
import { PaginatedClientTiktokTtoAccounts, QueryClientTiktokTtoAccountsArgs } from '../../gql/social/graphql';

export const useClientTiktokTtoAccountsQuery = (
  variables: QueryClientTiktokTtoAccountsArgs,
  options: Partial<Omit<UseQueryArgs<PaginatedClientTiktokTtoAccounts, QueryClientTiktokTtoAccountsArgs>, 'query' | 'variables'>> = {}
) => {
  return useQuery({
    query: gql`
      query GetClientTiktokTtoAccounts($clientId: String!, $paging: PagingInput) {
        clientTiktokTtoAccounts(
          clientId: $clientId
          paging: $paging
        ) {
          items {
            clientId
            tiktokTtoAccountId
            tiktokTtoAccount {
              tiktokTtoAccountId
              accountName
              businessVerificationStatus
              adAccounts { 
                tiktokAdAccountId
              }
            }
            ttoCampaignSettings {
              enabled
            }
          }
          pageInfo {
            totalCount
            totalPages
            currentPage
            limit
          }
        }
      }
    `,
    variables,
    ...options,
  });
};
